import { useEffect, useState } from "react";
import { createCategory, getAdminCategories } from "../httpService";
import Button from "./button.jsx";

export default function CategoryDropdown({ value, onChange, error }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState("");
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    getAdminCategories()
      .then(setCategories)
      .catch(() => {
        // silently ignore fetch errors
      })
      .finally(() => setLoading(false));
  }, []);

  function slugify(name) {
    return name.toLowerCase().replace(/\s+/g, "_");
  }

  async function handleAddNew() {
    const trimmed = newName.trim();
    if (!trimmed) return;
    const slug = slugify(trimmed);
    setCreating(true);
    try {
      await createCategory(slug, trimmed);
      setCategories((prev) => [...prev, { slug, name: trimmed, sortOrder: 0 }]);
      onChange(slug);
      setAdding(false);
      setNewName("");
    } catch {
      alert("Kunde inte skapa kategori");
    } finally {
      setCreating(false);
    }
  }

  if (loading) {
    return (
      <div>
        <span className="block text-text-body text-sm font-bold mb-2">Kategori</span>
        <div className="border border-border-default rounded py-2 px-3 text-sm text-text-muted">
          Laddar...
        </div>
      </div>
    );
  }

  return (
    <div>
      <label htmlFor="category-select" className="block text-text-body text-sm font-bold mb-2">
        Kategori
      </label>
      {adding ? (
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Kategorinamn"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleAddNew();
              if (e.key === "Escape") {
                setAdding(false);
                setNewName("");
              }
            }}
            className="flex-1 border border-border-default rounded py-2 px-3 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
          />
          <Button type="button" onClick={handleAddNew} loading={creating} size="sm">
            Skapa
          </Button>
          <button
            type="button"
            onClick={() => {
              setAdding(false);
              setNewName("");
            }}
            className="text-sm text-text-muted hover:text-text-body px-2"
          >
            Avbryt
          </button>
        </div>
      ) : (
        <div className="flex gap-2">
          <select
            id="category-select"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`appearance-none rounded border ${error ? "border-error" : "border-border-default"} flex-1 py-2 px-3 text-text-body leading-tight text-sm focus:ring-2 focus:ring-primary focus:outline-none`}
          >
            <option value="">-- Välj kategori --</option>
            {categories.map((c) => (
              <option key={c.slug} value={c.slug}>
                {c.name || c.slug.replace(/_/g, " ")}
              </option>
            ))}
          </select>
          <button
            type="button"
            onClick={() => setAdding(true)}
            className="text-sm text-primary hover:underline whitespace-nowrap"
          >
            + Ny
          </button>
        </div>
      )}
      {error && <p className="text-error text-sm mt-1">{error}</p>}
    </div>
  );
}
